"use client";

import { Moon } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { LightMoon } from "./Icons";

export default function ThemeSwitch({ isHomePage }: { isHomePage?: boolean }) {
  const [mounted, setMounted] = useState(false);
  const { setTheme, resolvedTheme } = useTheme();

  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return <div className="w-9 h-9 bg-transparent"></div>;
  }

  return (
    <div
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
      className="cursor-pointer p-2"
    >
      <Moon
        className={`${isHomePage ? "text-white" : "text-black dark:text-white"}`}
      />
    </div>
  );
}
